import { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { InputSize, DropdownValue } from 'components/Dropdown/types';
import { SELECT } from './constants';
import {
  createCashAccountsDropdown,
  getCompanyIdFromCashCompany
} from './helpers';
import { StyledDropdown } from './styled';
import { CashInBankInterCompanyType } from './types';

export const CashInBankInterCompanyDropdown = ({
  cashAccounts,
  selectedCashCompany,
  isLoading,
  setSelectedCashInBank
}: CashInBankInterCompanyType): React.JSX.Element => {
  const intl = useIntl();
  const [cashInBankAccount, setCashInBankAccount] = useState<DropdownValue>({
    label: SELECT,
    value: SELECT
  });
  const [cashAccountsOptions, setCashAccountsOptions] =
    useState<DropdownValue[]>();

  const handleCashInBankAccounts = (selectedValue: DropdownValue) => {
    setCashInBankAccount(selectedValue);
    setSelectedCashInBank(selectedValue);
  };

  useEffect(() => {
    if (selectedCashCompany && selectedCashCompany?.value !== SELECT) {
      const companyId = getCompanyIdFromCashCompany(selectedCashCompany);
      setCashAccountsOptions(
        createCashAccountsDropdown(cashAccounts, companyId)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCashCompany?.value]);

  useEffect(() => {
    if (cashAccountsOptions) {
      setCashInBankAccount(cashAccountsOptions?.[0]);
      setSelectedCashInBank(cashAccountsOptions?.[0]);
    }
  }, [cashAccountsOptions, setSelectedCashInBank]);

  return (
    <StyledDropdown
      isLoading={isLoading}
      inputId="cashInBankInterCompanyAccount"
      dataTestId="cashInBankInterCompanyAccount"
      label={
        <FormattedMessage
          description="Label for Cash In Bank Accounts dropdown"
          defaultMessage="Cash in Bank"
        />
      }
      placeHolder={intl.formatMessage({
        description: 'Place holder message for Cash Company',
        defaultMessage: 'Select'
      })}
      onChange={handleCashInBankAccounts}
      options={cashAccountsOptions || []}
      value={cashInBankAccount}
      size={InputSize.STANDARD}
      menuListStyles={{ minWidth: '250px', maxWidth: '400px' }}
      isRequired
      errorMessage={
        <FormattedMessage
          description="Label for select a Cash In Bank Account"
          defaultMessage="CIB Account is required"
        />
      }
      enableCustomValidation
    />
  );
};
